import { useQuery } from '@tanstack/react-query';

import axios, { parseAxiosError } from '@/portainer/services/axios';
import { useEnvironmentId } from '@/react/hooks/useEnvironmentId';
import { withGlobalError } from '@/react-tools/react-query';
import { EnvironmentId } from '@/react/portainer/environments/types';

import { Registry } from '../types/registry';

import { buildUrl } from './build-url';

export async function ping(
  registryId: Registry['Id'],
  endpointId: EnvironmentId,
  { forceNew }: { forceNew?: boolean } = {}
) {
  try {
    const { data } = await axios.get(`${buildUrl(registryId)}/v2/`, {
      params: { endpointId },
      headers: {
        Accept: 'application/json',
        ...(forceNew ? { 'X-RegistryManagement-ForceNew': '1' } : {}),
      },
    });
    return data;
  } catch (e) {
    throw parseAxiosError(e as Error);
  }
}

export function useRegistryPing(
  registryId: Registry['Id'],
  options?: { enabled?: boolean; forceNew?: boolean }
) {
  const environmentId = useEnvironmentId(false);

  return useQuery(
    ['environment', environmentId, 'registries', registryId, 'ping'],
    () => ping(registryId, environmentId, { forceNew: options?.forceNew }),
    {
      ...options,
      ...withGlobalError(),
    }
  );
}
